import Service from './abstract';
import _ from 'lodash';

const defaultWith = {
    tiny: false
};
class Cashflow extends Service {
    constructor () {
        super('cashflow');
    }

    getVouchers (options = {}) {
        const opts = {
            url: `${this.basePath}/vouchers`,
            qs: _.defaultsDeep({}, options, defaultWith),
        };

        return this.get(opts);
    }
}

export default new Cashflow();
